
import user from './interface/user'
import common from './interface/common'
import works from './interface/works'
export default Object.assign(
  user,
  common,
  works
)



// WEBPACK FOOTER //
// ./src/api/index.js